import React, { useState } from "react";
import successpic from "assets/images/uploadfiles/uploadSuccess.svg";
import failed from "assets/images/uploadfiles/failed.svg";
import showDark from "assets/images/manageTeam/show.svg";
import showLight from "assets/images/manageTeam/showdark.svg";


// Sample data
// const status = [
//   { status: "true", operations: "Upload", message: "File uploaded successfully" },
//   { status: "Error", operations: "Delete", message: "Permission denied" },
//   { status: "Warning", operations: "Sync", message: "Out of sync" },
// ];
import "./status.scss";
import Button from "components/Button/index";
import useTheme from "hooks/observer";

const StatusTable = (
    {
        status
    }
) => {
    const theme = useTheme();
    const [selectedMessage, setSelectedMessage] = useState("");
    const show = theme === "light" ? showLight : showDark;

    return (
        <div className="status-table">
            <table className="status-table__table">
                <thead className="status-table__thead">
                    <tr>
                        <th className="left-align">Operations</th>
                        {/* <th>Message</th> */}
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(status) && status.length > 0 ? (
                        status.map((item, idx) => (
                            <tr key={idx}>
                                <td className="left-align">{item.operations}</td>

                                <td>{item.status == "true" ?
                                    <img src={successpic} alt="Success"></img>
                                    :
                                    <img src={failed} alt="Failure" ></img>
                                }
                                </td>
                                {item.status != "true" && <td>
                                    <div>
                                        <img src={show} alt="Show" onClick={() => setSelectedMessage(item.message)}></img>
                                    </div>
                                </td>}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={3} className="status-table__empty">
                                No statuses available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {selectedMessage && (
                <div className="status-table__modal-overlay">
                    <div className="status-table__modal">
                        <h2>Full Message</h2>
                        <p>{selectedMessage}</p>

                        <Button
                            type="violet"
                            title="Close"
                            onClick={() => setSelectedMessage(null)}
                            height="fit-content"
                            width="fit-content"
                        />
                    </div>
                </div>
            )}
        </div>

    );
};

export default StatusTable;
